
import React from 'react';

const HeroBackground = () => {
  return (
    <>
      {/* Static background elements - animations removed for performance */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-64 h-64 md:w-96 md:h-96 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-48 h-48 md:w-80 md:h-80 bg-gradient-to-r from-emerald-500/30 to-cyan-500/30 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 w-40 h-40 md:w-60 md:h-60 bg-gradient-to-r from-yellow-400/20 to-orange-500/20 rounded-full blur-2xl transform -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Mesh gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-gray-900/20 to-black/40"></div>
    </>
  );
};

export default HeroBackground;
